


















































import {Component, Prop, Vue} from "vue-property-decorator";
import PlayerHead from "./PlayerHead.vue";
import Player from "./Player.vue";
import {PlayerConfig} from "@/interfaces/player.interface";
import {bus} from "@/plugins/bus";
import {isMobile} from 'mobile-device-detect';

@Component({
  components: {
    PlayerHead,
    Player
  }
})
export default class VideoSync extends Vue {
  @Prop() item;

  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  ignorePageMarginBreakpoint = PlayerConfig.IgnorePageMarginBreakpoints.MOBILE;
  minRatio: number = 4/3;
  mobile: boolean = false;
  buffered = false;
  $refs: any;
  firstStart = true;

  get isSynchronous(): boolean {return this.mobile ? false : this.item.play_mode === 'both';}

  mounted() {
    window['vimeoPlayers'] = [];
    this.mobile = isMobile;
  }

  synchronousAction(data) {
    if (!this.isSynchronous || this.mobile || !(this.$refs as any).playerFirst || !(this.$refs as any).playerSecond) return;

    let timesStart: number[] = [this.item.film_left_col.video_start, this.item.film_right_col.video_start];
    let firstOffset = timesStart[0] - timesStart[1];
    let secondOffset = timesStart[1] - timesStart[0];

    if (!this.firstStart) {
      if (data.action === 'buffering' && !this.buffered) {
        this.buffered = true;
        data.action = 'time-change';
        if (data.name === 'playerFirst') this.$refs.playerSecond.synchronousAction(data);
        else this.$refs.playerFirst.synchronousAction(data);
      }
      else if (data.action === 'buffering' && this.buffered) {
        this.buffered = false;
        data.action = 'time-change';
      }
      this.firstStart = false;
    }

    if (data.action != 'buffering') {
      this.$refs.playerFirst.synchronousAction(data);
      this.$refs.playerSecond.synchronousAction(data);
    }
  }

  onVideoLoaded(ratio) {
    this.minRatio = Math.min(this.minRatio, ratio)
  }
}
